import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

import './styles.css'

const Options = ({toggleVal, setToggleVal}) => {

  const handleToggle = (event, newToggle) => {
    setToggleVal(newToggle);
  };

  const toggleChildren = [
    <ToggleButton value="left" key="left" sx={{height: "50px", width: "50px"}}>
      <p>+/-</p>
    </ToggleButton>,
    <ToggleButton value="center" key="center" sx={{height: "50px", width: "50px"}}>
      <FontAwesomeIcon icon={faSquare} style={{color: 'red'}}/>
    </ToggleButton>,
    <ToggleButton value="right" key="right" sx={{height: "50px", width: "50px"}}>
      <FontAwesomeIcon icon={faSquare} style={{color: 'blue'}}/>
    </ToggleButton>,
  ]

  console.log(toggleVal)

  return (
    <div className='options-container'>
        <h3 className='options-title'>Options</h3>
          <ToggleButtonGroup 
            value={toggleVal} 
            exclusive={true} 
            size="small" 
            onChange={handleToggle}
            orientation="horizontal"
            color="info"
          >
            {toggleChildren}
          </ToggleButtonGroup>
    </div>
  )
}

export default Options